import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ProductRequestChangesType } from '../../../types';

@Component({
  selector: 'product-request-changes',
  templateUrl: './product-request-changes.component.html',
  styleUrls: ['./product-request-changes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductRequestChangesComponent {
  @Input() items?: ProductRequestChangesType[];
  @Input() creatorId?: string;
}
